import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import { languages } from "../../../utils/enums";

import IconButton from "../IconButton";
import Dropdown from "../Dropdown";
import ColumnTitleWithIcon from "../ColumnTitleWithIcon";
import { getTranslateTitle } from '../../../utils/objects-util.js';

const SectionItemLanguageEditor = ({ t, value, column, onPropChange }) => {
    const values = languages();
    const [selectedValue, setSelectedValue] = useState(null);
    
    const handleOnAdd = () => {
        return new Promise((resolve, reject)=> {
            if(selectedValue && (!value || !Object.keys(value).includes(selectedValue))) {
                resolve();  
                onPropChange({ [column.accessor]: { ...value, [selectedValue]: "" } });
                setSelectedValue(null);
            } else {
                reject();
            }           
        });
    }

    const handleOnChange = (key, newValue) => {
        onPropChange({ [column.accessor]: { ...value, [key]: newValue } });
    }

    const handleOnRemove = key => {
        return new Promise(resolve=> {
            resolve();
            if(!column.isReadonly){
                const newObject = Object.assign({}, value); //Fix for update value link
                delete newObject[key];
                onPropChange({ [column.accessor]: newObject });
            }
        });
    }

    return (
        <div className={classNames("sectionItemLanguageEditor", { full: column.isFullWidth })}>
            <ColumnTitleWithIcon
                column={{...column, title: "settings.businessCategories.SELECT_LANGUAGE_LABEL"}}
                item={value}
                onPropChange={onPropChange}
            />
            <div className={classNames("arrayItemsAddBlock")}>
                <Dropdown values={values.filter(language=> !value || !Object.keys(value).includes(language.key))}
                    labelField="value"
                    valueField="key"
                    searchBy="value"
                    placeholder={""}
                    value={selectedValue && values.find(f=> f.key === selectedValue)["value"]}
                    onSelect={val => setSelectedValue(val.key)}
                    readonly={column.isReadonly}
                />
                <IconButton isIcon={true}
                    iconName={"newOrder"}
                    tooltipText={t("settings.businessCategories.ADD_CATEGORY_TRANSLATE_LABEL")}
                    onClick={handleOnAdd}
                />
            </div>
            <div className={classNames("arrayItems")}>
                <div className={classNames("label")}>{getTranslateTitle(column.title)}</div>
                {value && Object.keys(value).map(key => (
                    <div key={`sectionItemArrayItem-${column.accessor}-${key}`} className={classNames("sectionItemArrayItem")}>
                        <div className={classNames("propItemLabel")}>
                            {values.find(f=> f.key === key)["value"]}
                        </div>
                        {column.isTextArea
                            ? (
                                <textarea value={value[key] || ""} className={classNames("sectionItemArrayItemValue")}
                                    rows="10"
                                    onChange={e => handleOnChange(key, e.currentTarget.value)}
                                />
                            )
                            : (
                                <input type="text" value={value[key] || ""} className={classNames("sectionItemArrayItemValue")}
                                    onChange={e => handleOnChange(key, e.currentTarget.value)}
                                />
                            )}
                        <IconButton isIcon={true}
                            iconName={"orderDelete"}
                            tooltipText={t("settings.businessCategories.REMOVE_CATEGORY_TRANSLATE_LABEL")}
                            onClick={()=> handleOnRemove(key)}
                        />
                    </div>
                ))}
            </div>            
        </div>
    );
}

export default withTranslation()(SectionItemLanguageEditor);